export const blockColumns = [
	
	'core/table', {
		className: 'page__content-infotable-table -table', 
	}, 
];  